<template>
    <div id="visitor-attributes">
        <a-alert :description="$t('settings.toInformDescription')" type="info" show-icon />
        <a-table
            :columns="columns"
            :data-source="getAttributes()"
            class="attr-table"
            :pagination="false"
            key="attr-table"
        >
            <div
                slot="name"
                slot-scope="text, record"
                @click="
                    editAttributeId = record._id;
                    editAttributeValue = text;
                "
                @mouseleave="editAttributeId = null"
                style="width: 100px"
                key="name"
            >
                <div v-if="editAttributeId == record._id">
                    <a-input
                        class="edit-input"
                        v-model="editAttributeValue"
                        @change="updateAttributeName(record._id, editAttributeValue)"
                    >
                    </a-input>
                </div>
                <div class="attr-name" v-else><span class="material-icons"> edit_note </span> {{ text }}</div>
            </div>
            <span slot="usingVisitor" slot-scope="usingVisitor" key="usingVisitor">
                <a-button disabled>{{ $t("settings.showVisitor") }}</a-button>
            </span>
            <span slot="visible" slot-scope="text, record">
                <a-switch
                    class="md-warning ml-3"
                    name="writing"
                    v-model="record.visible"
                    @change="updateAttrVisible(record._id, text)"
                />
            </span>
            <div slot="process" slot-scope="text, record" key="process">
                <a-button class="process-button" type="danger" shape="circle" @click="deleteAttribute(record._id)">
                    <span class="material-icons">delete</span>
                </a-button>
            </div>
        </a-table>
    </div>
</template>
<script>
import Modal from "../../../../components/common/Modal2";
import { mapActions } from "vuex";

export default {
    name: "VisitorAttributes",
    components: { Modal },
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: () => {
        return {
            columns: [
                {
                    title: "Name",
                    dataIndex: "label",
                    key: "label",
                    scopedSlots: { customRender: "name" },
                },
                {
                    title: "Label",
                    dataIndex: "name",
                    key: "name",
                },
                {
                    title: "Creator",
                    dataIndex: "createdBy.name",
                    key: "createdBy.name",
                },
                {
                    title: "",
                    dataIndex: "usingVisitor",
                    key: "usingVisitor",
                    scopedSlots: { customRender: "usingVisitor" },
                },
                {
                    title: "Hide / Show",
                    dataIndex: "visible",
                    key: "visible",
                    scopedSlots: { customRender: "visible" },
                },
                {
                    title: "",
                    dataIndex: "_id",
                    key: "_id",
                    scopedSlots: { customRender: "process" },
                },
            ],
            types: {
                text: "Yazı",
                email: "Mail",
                phone: "Telefon",
                number: "Sayı",
                url: "URL",
                date: "Tarih",
                dropdown: "Seçilebilir",
            },
            updateAttrDebouce: null,
            editAttributeId: null,
            editAttributeValue: null,
        };
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
            deleteContactProperty: "contactProperty/deleteContactProperty",
            updateContactProperty: "contactProperty/updateContactProperty",
        }),
        getAttributes() {
            let newAttributes = [
                ...this.value.map((attribute) => ({
                    ...attribute,
                    editable: true,
                    icon: "tag",
                })),
            ];
            return newAttributes;
        },
        deleteAttribute(id) {
            this.deleteContactProperty(id).then(() => {
                this.$message.success({
                    content: this.$t("settings.profileInfoRemoved"),
                    duration: 2,
                    key: "saved",
                });
            });
        },
        updateAttribute() {
            this.updateContactProperty({
                id: this.editedAttribute._id,
                data: this.form,
            }).then((res) => {
                this.editedAttribute = false;
                this.$message.success({
                    content: this.$t("settings.newValueUpdated"),
                    duration: 2,
                    key: "saved",
                });
            });
        },
        updateAttrVisible(id, visible) {
            this.updateContactProperty({
                id,
                data: {
                    visible: !visible,
                },
            });
        },
        updateAttributeName(id, val) {
            if (this.updateAttrDebouce) clearTimeout(this.updateAttrDebouce);
            this.updateAttrDebouce = setTimeout(() => {
                this.updateContactProperty({
                    id,
                    data: {
                        label: val,
                    },
                });
            }, 300);
        },
    },
};
</script>
<style lang="scss">
.dark-mode {
    .attribute-item {
        background: #1e1e2d !important;
        border: 1px solid var(--color-border-default);

        .attribute-value span {
            color: white !important;
        }
    }
}

.attribute-item {
    .ant-switch-checked {
        background-color: var(--color-bg-primary-default);
    }
}

#visitor-attributes {
    .info {
        width: 100%;
    }

    .attr-table {
        width: 100%;
        margin-top: 15px;
    }

    .edit-input {
        width: 200px;
    }

    .attr-name {
        cursor: text;
        display: flex;
        align-items: center;

        span.material-icons {
            margin-right: 4px;
        }
    }
}

.process-button {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
<style lang="scss" scoped>
#visitor-attributes {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .info {
        width: 100%;
    }

    .attr-table {
        width: 100%;
        margin-top: 15px;
    }
}

.new-theme .info {
    cursor: pointer;
    display: -ms-flexbox;
    height: 80px;
    position: relative;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}

#visitor-attributes {
    .ant-alert {
        width: 100%;
    }
}
</style>
